<script setup>
 
</script>

<template>
 <div class="accordion mb-4 w-75 mx-auto" id="accordion">
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingOne">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
          aria-expanded="false" aria-controls="collapseOne">
          Sobre os Atos Normativos
        </button>
      </h2>
      <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordion">
        <div class="accordion-body">
          <div class="apresentacao">
            <p>
              Disponibiliza os Atos Normativos referentes ao funcionamento do Supremo Tribunal Federal tais como
              Regulamento da
              Secretaria, Emendas Regimentais, Resoluções editadas a partir de 1980, Atos Regulamentares, Instruções
              Normativas,
              Portarias Conjuntas da Presidência (GP) e Normas de Prazo e Feriados (Aviso, Decreto-Lei e Lei).
              <br />
              <br />

              O formulário de busca permite a recuperação por assunto, tipo de ato, número e ano da publicação.

              <br />
              <br />

              Além da norma integral, o banco de dados permite a recuperação de alguns textos consolidados de normas com
              as suas
              alterações e link para o texto.

              <br />
              <br />
              As informações disponíveis no banco de dados têm caráter, exclusivamente, informativo e não oficial. Dessa
              maneira,
              não é dispensada a consulta aos textos publicados nas fontes oficiais.
            </p>
            <div class="container-dicas">
              <p style="font-weight: 400">
                DÚVIDAS E SUGESTÕES: bibliotecadigital@stf.jus.br
                <br />
              </p>
            </div>
            <div class="container-dicas">
              <p style="font-weight: 600">
                DICAS DE CONSULTA
                <br />
              </p>
              <ul>
                <li>
                  Utilize qualquer palavra que esteja dentro do conteúdo do documento;
                </li>
                <li>É indiferente a utilização de maiúsculas, minúsculas e acentos;</li>                
                <li>
                  <strong>Não</strong> utilize o navegador
                  <strong>Internet Explorer</strong> para esta funcionalidade.
                </li>
              </ul>
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
 
</style>